export default [
  {
    path: "/registration",
    name: "Registrierung",
    meta: {
      authorize: false
    },
    component: () =>
      import(
        /* webpackChunkName: "registration" */ "@/blitza/views/registration/RegistrationForm.vue"
      )
  },
  {
    path: "/confirm",
    name: "Bestätigung",
    meta: {
      authorize: false
    },
    component: () =>
      import(
        /* webpackChunkName: "confirm" */ "@/blitza/views/registration/ConfirmContainer.vue"
      )
  },
  {
    path: "/patient",
    name: "Profil",
    meta: {
      authorize: true
    },
    component: () =>
      import(
        /* webpackChunkName: "secondopinions" */ "@/blitza/views/secondopinions/PatientForm.vue"
      )
  },
  {
    path: "/secondopinions",
    name: "Zweitmeinungen",
    meta: {
      authorize: true
    },
    component: () =>
      import(
        /* webpackChunkName: "secondopinions" */ "@/blitza/views/secondopinions/SecondOpinionContainer.vue"
      )
  },
  {
    path: "/secondopinions/:id",
    name: "Zweitmeinung",
    meta: {
      authorize: true
    },
    component: () =>
      import(
        /* webpackChunkName: "secondopinions" */ "@/blitza/views/secondopinions/SecondOpinionForm.vue"
      )
  },
  {
    path: "secondopinions/:id/questionnaire",
    name: "Fragebogen",
    meta: {
      authorize: true
    },
    component: () =>
      import(
        /* webpackChunkName: "secondopinions" */ "@/blitza/views/secondopinions/QuestionnaireForm.vue"
      )
  }
]
